import moment from "moment";

export const summarySubtitle = (email, isPayoff, isPrincipalOnly, nextDueDate) => {
  let subtitle = `Your payment has been successfully submitted. A confirmation email has been sent to email address: ${email}`;

  if (isPayoff) {
    subtitle =
      "After your payment posts, your loan will be paid off. Congratulations! You’ve worked hard to reach this major milestone.";
  }

  if (isPrincipalOnly) {
    subtitle = `Your principal only payment has been successfully submitted. Please note that your regular payment is still due on ${moment(
      nextDueDate
    ).format("MM/DD/YYYY")}. A confirmation email has been sent to email address: ${email}`;
  }

  return subtitle;
};


// WEBPACK FOOTER //
// ./src/components/authenticated-payments/misc/summary-subtitle.component.js